<div class="col-12 h-full">
  <p-tabView class="w-full h-full">
    <p-tabPanel header="Reimposta Password">
      <div class="col-12 h-full flex align-content-center justify-content-center">
        <app-forgot [internal]="true" class="w-full h-full flex align-content-center"> </app-forgot>
      </div>
    </p-tabPanel>
    <p-tabPanel header="Scarica Dati">
      <div class="col-12 h-full flex flex-wrap align-content-center justify-content-center form-signin text-center mb-4 pr-0 pl-0">
        <div class="flex justify-content-center align-content-center">
          <div class="w-full h-full flex flex-wrap justify-content-center align-content-center">
            <div class="text-900 text-3xl font-bold text-center">
              Scarica i tuoi dati
            </div>
            <div class="w-full flex justify-content-center p-0">
              <div class="w-full justify-content-center block py-4 mx-2">
                <button pButton pRipple label="Scarica" icon="pi pi-user" class="mt-2 w-full p-button-rounded" (click)="getProfileExport()"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>
    <p-tabPanel header="Newsletter">
      <div class="col-12 h-full flex flex-wrap align-content-center justify-content-center form-signin text-center mb-4 pr-0 pl-0">
        <div class="flex col-12 justify-content-center">
          <p-checkbox id="rememberme" [binary]="true" styleClass="mr-2" [(ngModel)]="registryDto.AccettoInvioEmailFlag"></p-checkbox>
          <label>Accetto l’invio di e-mail con offerte di lavoro</label>
        </div>
        <div class="col-12 md:col-2 lg:col-2 p-0">
          <button pButton pRipple label="Salva" class="mt-4 mb-2 w-full p-button-rounded" (click)="registryUpdate()"></button>
        </div>
      </div>
    </p-tabPanel>
  </p-tabView>
</div>

